<template>
  <div class="manage">
    <div class="groupinfo radiusshadow">
      <div>{{regname}}</div>
      <div v-for="item in groupinfo" :key="item.id" class="terms">
        <div class="ctitle">{{item.show_name}}</div>
        <div class="cvalue">{{item.value}}</div>
      </div>
      <div class="cbtn">
        <Button type="warning" plain @click="editgroup" round v-if="submitstatus">修 改</Button>
        <Button type="default" round disabled v-else>团队信息已确认</Button>
      </div>
    </div>

    <div class="payinfom radiusshadow" v-if="paystatetips">
      <div>{{paystatetips}}</div>
      <div v-if="paydesc">{{paydesc}}</div>
      <Button
        type="warning"
        round
        :disabled="paybtndisabled"
        v-if="!isfree&&!ispay"
        @click="Pay"
      >{{paybtntips}}</Button>
    </div>
    <div v-else class="line">
      <Divider></Divider>
    </div>

    <div class="radiusshadow payinfo groupmembers">
      <template v-if="!submited">
        <template v-if="submitstatus">
          <div>完善成员名单</div>
          <div>你需要在{{registermatchinfo.submitendtime}}前提交成员名单</div>
        </template>
        <template v-else>
          <div></div>
          <div></div>
        </template>
        <div v-if="memberList.length==0" @click="membermanage">
          <img src="@/images/add@3x.png" />
        </div>
        <div v-else class="memberinfo">
          <div v-for="item in memberList" :key="item.id" class="memberitem">
            <div v-if="item.nameshowtype=='img'">
              <img :src="item.nameshow" />
            </div>
            <div v-else>
              <div class="itemheader">{{item.nameshow}}</div>
            </div>
            {{item.name}}
          </div>
        </div>
        <div class="operatebtn" v-if="submitstatus">
          <Button plain type="warning" round @click="membermanage">管理成员</Button>
          <Button type="warning" round @click="submitmember">提交成员名单</Button>
        </div>

        <div class="cbtn" v-else>
          <Button round type="default" disabled>提交成员名单</Button>
        </div>
      </template>
      <template v-else>
        <div>成员列表</div>
        <div v-if="submitstatus">
          你需要在{{registermatchinfo.submitendtime}}前确认成员名单
          <div>在这之前你可以进行修改</div>
        </div>
        <div v-else></div>

        <div class="memberinfo">
          <div v-for="item in memberList" class="memberitem" :key="item.id" v-show="item.state==1">
            <div v-if="item.nameshowtype=='img'">
              <img :src="item.nameshow" />
            </div>
            <div v-else>
              <div class="itemheader">{{item.nameshow}}</div>
            </div>
            {{item.name}}
          </div>
        </div>

        <div style="margin-top:10px;margin-bottom:10px;">未提交成员</div>

        <div class="memberinfo nojoingame">
          <div v-for="item in memberList" class="memberitem" :key="item.id" v-show="item.state==2">
            <div v-if="item.nameshowtype=='img'">
              <img :src="item.nameshow" />
            </div>
            <div v-else>
              <div class="itemheader">{{item.nameshow}}</div>
            </div>
            {{item.name}}
          </div>
        </div>

        <div class="operatebtn" v-if="submitstatus">
          <Button plain type="warning" round @click="membermanage">管理成员</Button>
          <Button type="warning" round @click="submitmember">提交成员名单</Button>
        </div>

        <div class="cbtn" v-else>
          <Button round type="default" disabled>名单已确认</Button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import "./manage.less";
import { groupinfo, matchinfo, prememberlist, orderdetail } from "@/libs/api";
import { Button, Divider } from "vant";
import { setStorage, getStorage, formatDate } from "@/libs/utils";

export default {
  name: "mainapply",
  components: {
    Button,
    Divider
  },
  data() {
    return {
      regname: "",
      groupinfo: [],
      isfree: false,
      regstatus: true,
      registermatchinfo: {},
      submitstatus: true,
      paystatetips: "",
      paydesc: "",
      paybtntips: "",
      paybtndisabled: false,
      ispay: false,
      needcheck: false,
      memberList: [],
      submited: false,
      postparams: {},
      code: ""
    };
  },
  methods: {
    groupPay() {
      var params = this.postparams;
      params.paytype = 2;
      params.paymethod = 1;
      params.returnurl = "wap";
      var url = window.location.href;
      params.payurl = url;
      this.$router.replace({ name: "mppay", params: params });
    },
    editgroup() {
      var editparams = this.postparams;
      editparams.groupinfo = this.groupinfo;
      editparams.categoryid = this.registermatchinfo.categoryid;
      //缓存
      try {
        setStorage("editgroupinfo", editparams, true);
        this.$router.push({ name: "editgroup" });
      } catch (e) {
        // console.log('网络异常')
      }
    },
    Pay() {
      //如果有邀请码 下一页 没有 当前页面
      if (this.registermatchinfo.hascode == 1) {
        this.$router.push({
          name: "orderconfirm",
          params: {
            typeid: this.postparams.typeid,
            rgid: this.postparams.rgid,
            rrid: this.postparams.rrid
          }
        });
      } else {
        this.groupPay();
      }
    },
    membermanage() {
      this.postparams.groupcode = this.registermatchinfo.groupcode;
      this.$router.push({ name: "member", params: this.postparams });
    },
    submitmember() {
      this.postparams.groupcode = this.registermatchinfo.groupcode;
      this.$router.push({ name: "membersubmit", params: this.postparams });
    },
    groupInfo() {
      groupinfo(this.postparams).then(res => {
        if (res.status == 200) {
          if (res.data) {
            //获取name
            res.data.list.forEach(item => {
              if (item.key_name == "mv_regname") {
                this.regname = item.value;
              }
            });
            this.groupinfo = res.data.list;
          } else {
            this.$router.push({ name: "term", params: this.postparams });
          }
        }
      });
    },
    matchInfo() {
      matchinfo(this.postparams).then(res => {
        if (res.status == 200) {
          if (res.data) {
            var date = new Date();
            var currenttime = Date.parse(new Date());

            date.setTime(res.data.endtime * 1000);
            if (currenttime > res.data.endtime * 1000) {
              this.regstatus = false;
            }
            if (currenttime > res.data.submitendtime * 1000) {
              this.submitstatus = false;
            }

            //时间格式化
            res.data.endtime = formatDate(date, "Y年M月d日");
            date.setTime(res.data.submitendtime * 1000);
            res.data.submitendtime = formatDate(date, "Y年M月d日");
            this.registermatchinfo = res.data;
            orderdetail(this.postparams).then(res => {
              if (res.status == 200 && res.data) {
                var orderinfo = res.data.order;
                //先检查审核
                if (orderinfo.ischeck == 1) {
                  //未支付
                  if (orderinfo.state * 1 !== 1) {
                    this.paystatetips = "支付金额:¥" + orderinfo.fees;
                    this.paydesc =
                      "你需要在" +
                      this.registermatchinfo.endtime +
                      "前完成支付";
                    this.paybtntips = "支付";
                    this.paybtndisabled = false;
                  } else {
                    this.paystatetips = "已支付";
                    this.paydesc = "";
                    this.paybtntips = "已支付";
                    this.paybtndisabled = true;
                    this.ispay = true;
                  }
                } else {
                  this.paystatetips = "报名审核中";
                  this.paydesc = "你的报名信息已提交组委会审核";
                  this.paybtntips = "支付";
                  this.paybtndisabled = true;
                  this.needcheck = true;
                }

                //判断是否免费
                if (orderinfo.fees * 1 == 0) {
                  this.isfree = true;
                }



                //判断 如果 不需要审核 且 不要钱 嘿嘿
                if (!this.needcheck && this.isfree && orderinfo.state != 1) {
                  this.groupPay();
                }
              }
            });
          }
        }
      });
    },
    prememberList() {
      prememberlist(this.postparams).then(res => {
        if (res.status == 200) {
          if (res.data) {
            res.data.list.forEach(item => {
              item.nameshowtype = "text";
              item.attrs.forEach(citem => {
                if (citem.key_name == "mv_name") {
                  item.name = citem.value;
                  item.nameshow = citem.value.substr(0, 1);
                }
                if (citem.key_name == "mv_avatar") {
                  item.nameshowtype = "img";
                  item.nameshow = citem.value;
                }
              });
              if (item.state == 1) {
                this.submited = true;
              }
            });

            this.memberList = res.data.list;
          }
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      // var currentUrl = window.location.pathname
      let userinfo = getStorage("userInfo");
      // console.log(userinfo)
      let param = this.$route.params;
      let arr = Object.keys(param);
      if (arr.length == 0) {
        this.postparams = getStorage("manage");
      } else {
        this.postparams = this.$route.params;
        setStorage("manage", this.postparams, true);
      }
      this.postparams.urid = userinfo.urid;
      this.postparams.token = userinfo.token;
      this.postparams.openid = userinfo.openid;
      this.groupInfo();
      this.matchInfo();
      this.prememberList();
    });
  }
};
</script>